import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, AlertIcon, Box, Spinner, useToast, HStack } from "@chakra-ui/react";
import Navbar from "./Navbar";
import WatermarkBackground from "./components/WatermarkBackground";
import { getSignedLineAdvice } from "./services/PlacingAPI";
import { showApiErrorToast } from "./utils/showApiToast";
import CarrierSignedLineAdviceView from "./components/placing/CarrierSignedLineAdviceView";
import PlacementCodify, { SignedContractPanel } from "./components/codify/PlacementCodify";

/** A signed line advice sent to one of the carrier's parties. */
const PlacingSignedLineAdvicePage = () => {
  const { signedLineAdviceId } = useParams();
  const toast = useToast();
  const [advice, setAdvice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setAdvice(await getSignedLineAdvice(signedLineAdviceId));
      setError(null);
    } catch (err) {
      setError(err);
      showApiErrorToast(toast, err, { title: "Couldn't load signed line advice" });
    } finally {
      setLoading(false);
    }
  }, [signedLineAdviceId, toast]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box position="relative" minHeight="100vh">
      <WatermarkBackground />
      <Navbar />
      <Box p={6} maxW="1400px" mx="auto">
        {loading ? (
          <Spinner />
        ) : error || !advice ? (
          <Alert status="error"><AlertIcon />{error?.message || "Signed line advice not found."}</Alert>
        ) : (
          <>
            {/* Your own Codify setting and run for this message (it starts as the page loads it) */}
            <HStack justify="flex-end" mb={3} spacing={2}>
              <PlacementCodify placementId={advice.placementId} message={{ trigger: "signed_line_advice", triggerId: advice._id }} refreshKey={advice._id} />
            </HStack>
            <CarrierSignedLineAdviceView advice={advice} />
            <Box mt={4}>
              <SignedContractPanel placementId={advice.placementId} message={{ trigger: "signed_line_advice", triggerId: advice._id }} refreshKey={advice._id} />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default PlacingSignedLineAdvicePage;
